export const hasMatchingId = (item, id) => String(item?.id) === String(id)

export const isHeaderItem = (item) => item?.type === 'header'

export const findHierarchyItem = (items, id) => {
  for (const item of items || []) {
    if (hasMatchingId(item, id)) return item

    const nestedItem = findHierarchyItem(item.hierarchy, id)
    if (nestedItem) return nestedItem
  }

  return null
}

const removeHierarchyItem = (items, id) => {
  for (let index = 0; index < (items || []).length; index += 1) {
    const item = items[index]

    if (hasMatchingId(item, id)) {
      return {
        hierarchy: [...items.slice(0, index), ...items.slice(index + 1)],
        removedItem: item,
      }
    }

    const nestedResult = removeHierarchyItem(item.hierarchy, id)
    if (nestedResult.removedItem) {
      const updatedItem = {
        ...item,
        hierarchy: nestedResult.hierarchy,
        isHierarchy: nestedResult.hierarchy.length > 0,
      }

      return {
        hierarchy: [...items.slice(0, index), updatedItem, ...items.slice(index + 1)],
        removedItem: nestedResult.removedItem,
      }
    }
  }

  return { hierarchy: items || [], removedItem: null }
}

const insertHierarchyItem = (items, targetId, itemToInsert) => {
  let inserted = false

  const hierarchy = (items || []).map((item) => {
    if (hasMatchingId(item, targetId)) {
      inserted = true
      return {
        ...item,
        hierarchy: [...(item.hierarchy || []), itemToInsert],
        isHierarchy: true,
      }
    }

    if (!inserted && item.hierarchy?.length) {
      const nestedResult = insertHierarchyItem(item.hierarchy, targetId, itemToInsert)
      if (nestedResult.inserted) {
        inserted = true
        return { ...item, hierarchy: nestedResult.hierarchy }
      }
    }

    return item
  })

  return { hierarchy, inserted }
}

export const moveHeaderIntoHeader = (hierarchy, draggedId, targetId) => {
  if (!draggedId || String(draggedId) === String(targetId)) return { hierarchy, moved: false }

  const draggedItem = findHierarchyItem(hierarchy, draggedId)
  const targetItem = findHierarchyItem(hierarchy, targetId)
  if (!isHeaderItem(draggedItem) || !isHeaderItem(targetItem)) return { hierarchy, moved: false }

  if (findHierarchyItem(draggedItem.hierarchy, targetId)) return { hierarchy, moved: false }

  const removalResult = removeHierarchyItem(hierarchy, draggedId)
  if (!removalResult.removedItem) return { hierarchy, moved: false }

  const movedItem = Object.prototype.hasOwnProperty.call(removalResult.removedItem, 'parentId')
    ? { ...removalResult.removedItem, parentId: targetItem.id }
    : removalResult.removedItem
  const insertionResult = insertHierarchyItem(removalResult.hierarchy, targetId, movedItem)

  return insertionResult.inserted ? { hierarchy: insertionResult.hierarchy, moved: true } : { hierarchy, moved: false }
}
